// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

.app-container {
    display: flex;
    flex-direction: column;
    font-family: 'Inter';
}

li.ant-menu-item,
li.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title {
    padding: 8px !important ;
}

li.ant-menu-item:hover svg path {
    stroke: #fff;
}

li.ant-menu-item .ant-menu-title-content {
    margin-left: 10px;
}

li.ant-menu-item-selected svg path {
    stroke: #fff;
}

li.ant-menu-submenu .ant-menu-submenu-title img,
li.ant-menu-item img {
    width: 24px;
    height: 24px;
}

ul.ant-menu-sub li.ant-menu-item {
    padding-left: 42px !important;
}
.nav-menu-wrapper {
    &::-webkit-scrollbar {
        width: 12px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--primary-blue-500);
        border-radius: 8px;
        border: 4px solid transparent;
        background-clip: content-box;
    }
}
.nav-menu-wrapper .gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title {
    color: #fff;
}
.dashboard-reports {
    .animate-bg-processing,
    .animate-bg-pending {
        animation: processing-flash 2000ms ease-in;
    }
    .animate-bg-complete {
        animation: success-flash 2000ms ease-in;
    }
    @keyframes success-flash {
        50% {
            background-color: var(--success-600) !;
        }
        0%,
        100% {
            background-color: transparent;
        }
    }
    @keyframes processing-flash {
        0% {
            background-color: var(--warning-500) !important;
        }
        100% {
            background-color: transparent;
        }
    }
}

.get-started .customStepCss .ant-steps-item-icon {
    margin-left: -0.5em;
    width: auto;
}

.get-started .customStepCss .ant-steps-item-title,
.get-started-COD .customStepCssCOD .ant-steps-item-title {
    width: 100%;
    padding: 0;
}

.get-started .customStepCss .ant-collapse-item {
    border-radius: 8px !important;
    border: 2px solid #0192ff;
    background: #fff;
    box-shadow: 0px 4px 4px 0px #d0e4ff;
    margin-top: 10px;
}

.get-started .customStepCss .ant-collapse-content-box {
    padding-top: 0px !important;
}

.get-started .customStepCss .subStepCustomCss .ant-steps-item-icon {
    margin-left: 0;
    width: 3%;
}

.get-started .customStepCss .stepMarkedDone .ant-collapse-item {
    border: 2px solid #0bc677;
}

/* sub-step-completed */

.get-started .customStepCss .ant-collapse-item:has(.sub-step-completed) {
    border: 2px solid #0bc677;
}

.get-started .customStepCss .ant-collapse-item:has(.sub-step-failed) {
    border: 2px solid #ff2618;
}

.invitation-form {
    .ant-form-vertical .ant-form-item-label label {
        height: auto;
    }
}
.edit-provider {
    font-size: 12px;
    height: fit-content;
    padding: 2px 8px;
    border: 1px solid rgba(0, 0, 0, 0.15);
}
.tag-icon {
    border: 1px solid rgba(22, 119, 255, 0.88);
    border-radius: 50%;
    width: 24px;
    padding: 4px;
    background: rgba(22, 119, 255, 0.08);
}
.gray-background {
    background: rgba(0, 0, 0, 0.06);
}
.bottom-border {
    border-bottom: 0.5px solid #ddd;
}
.border-radius-top {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.setting-menu-custom-css .ant-menu .ant-menu-item-selected {
    background-color: aliceblue;
    border: 1px solid #1677ff4a;
    color: #1677ff;
    font-weight: 500;
    font-size: 15px;
}

.setting-menu-custom-css .ant-menu-item {
    color: #000000e0;
    font-weight: 400;
    font-size: 15px;
    background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/library/styles/styles.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yCAAyC;QACzC,kBAAkB;QAClB,6BAA6B;QAC7B,4BAA4B;IAChC;AACJ;AACA;IACI,WAAW;AACf;AACA;IACI;;QAEI,0CAA0C;IAC9C;IACA;QACI,uCAAuC;IAC3C;IACA;QACI;YACI,sCAAsC;QAC1C;QACA;;YAEI,6BAA6B;QACjC;IACJ;IACA;QACI;YACI,+CAA+C;QACnD;QACA;YACI,6BAA6B;QACjC;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;;AAEvB;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;AACzC;AACA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.app-container {\n    display: flex;\n    flex-direction: column;\n    font-family: 'Inter';\n}\n\nli.ant-menu-item,\nli.ant-menu-submenu.ant-menu-submenu-inline .ant-menu-submenu-title {\n    padding: 8px !important ;\n}\n\nli.ant-menu-item:hover svg path {\n    stroke: #fff;\n}\n\nli.ant-menu-item .ant-menu-title-content {\n    margin-left: 10px;\n}\n\nli.ant-menu-item-selected svg path {\n    stroke: #fff;\n}\n\nli.ant-menu-submenu .ant-menu-submenu-title img,\nli.ant-menu-item img {\n    width: 24px;\n    height: 24px;\n}\n\nul.ant-menu-sub li.ant-menu-item {\n    padding-left: 42px !important;\n}\n.nav-menu-wrapper {\n    &::-webkit-scrollbar {\n        width: 12px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: var(--primary-blue-500);\n        border-radius: 8px;\n        border: 4px solid transparent;\n        background-clip: content-box;\n    }\n}\n.nav-menu-wrapper .gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title {\n    color: #fff;\n}\n.dashboard-reports {\n    .animate-bg-processing,\n    .animate-bg-pending {\n        animation: processing-flash 2000ms ease-in;\n    }\n    .animate-bg-complete {\n        animation: success-flash 2000ms ease-in;\n    }\n    @keyframes success-flash {\n        50% {\n            background-color: var(--success-600) !;\n        }\n        0%,\n        100% {\n            background-color: transparent;\n        }\n    }\n    @keyframes processing-flash {\n        0% {\n            background-color: var(--warning-500) !important;\n        }\n        100% {\n            background-color: transparent;\n        }\n    }\n}\n\n.get-started .customStepCss .ant-steps-item-icon {\n    margin-left: -0.5em;\n    width: auto;\n}\n\n.get-started .customStepCss .ant-steps-item-title,\n.get-started-COD .customStepCssCOD .ant-steps-item-title {\n    width: 100%;\n    padding: 0;\n}\n\n.get-started .customStepCss .ant-collapse-item {\n    border-radius: 8px !important;\n    border: 2px solid #0192ff;\n    background: #fff;\n    box-shadow: 0px 4px 4px 0px #d0e4ff;\n    margin-top: 10px;\n}\n\n.get-started .customStepCss .ant-collapse-content-box {\n    padding-top: 0px !important;\n}\n\n.get-started .customStepCss .subStepCustomCss .ant-steps-item-icon {\n    margin-left: 0;\n    width: 3%;\n}\n\n.get-started .customStepCss .stepMarkedDone .ant-collapse-item {\n    border: 2px solid #0bc677;\n}\n\n/* sub-step-completed */\n\n.get-started .customStepCss .ant-collapse-item:has(.sub-step-completed) {\n    border: 2px solid #0bc677;\n}\n\n.get-started .customStepCss .ant-collapse-item:has(.sub-step-failed) {\n    border: 2px solid #ff2618;\n}\n\n.invitation-form {\n    .ant-form-vertical .ant-form-item-label label {\n        height: auto;\n    }\n}\n.edit-provider {\n    font-size: 12px;\n    height: fit-content;\n    padding: 2px 8px;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n}\n.tag-icon {\n    border: 1px solid rgba(22, 119, 255, 0.88);\n    border-radius: 50%;\n    width: 24px;\n    padding: 4px;\n    background: rgba(22, 119, 255, 0.08);\n}\n.gray-background {\n    background: rgba(0, 0, 0, 0.06);\n}\n.bottom-border {\n    border-bottom: 0.5px solid #ddd;\n}\n.border-radius-top {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n}\n.setting-menu-custom-css .ant-menu .ant-menu-item-selected {\n    background-color: aliceblue;\n    border: 1px solid #1677ff4a;\n    color: #1677ff;\n    font-weight: 500;\n    font-size: 15px;\n}\n\n.setting-menu-custom-css .ant-menu-item {\n    color: #000000e0;\n    font-weight: 400;\n    font-size: 15px;\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
